(function($) {

	/**
	 * Header Mobile Submenus
	 *
	 * Handles toggling the header submenus on small screens
	 */

	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;

	$('.sub-menu-toggle').click( function(e){

		if ( $(this).parent().hasClass('menu-item-has-children') ) {

			if( !isMobile ) {

				// On Desktop, toggle the parent list-item and sub-menu "toggle" classes.

				if ( $(this).parent().hasClass('toggled') ) {
					$(this).parent().removeClass('toggled');
					$(this).next().removeClass('toggle');
				} else {
					$('#primary-menu').children('.toggled').removeClass('toggled');
					$(this).parent().addClass('toggled');
					$(this).next().addClass('toggle');
				}

			} else {

				// On Mobile, toggle the parent list-item "toggle" class only.
				// (no need to toggle the sub-menu "toggle" class as this is default device behaviour)

				if ( $(this).parent().hasClass('toggled') ) {
					$(this).parent().removeClass('toggled');
				} else {
					$('#primary-menu').children('.toggled').removeClass('toggled');
					$(this).parent().addClass('toggled');
				}

			}

		}

	});


	/**
	 * Footer Menus
	 *
	 * Handles toggling the footer menus on small screens
	 */

	var footer_menus = $( ".site-footer .widget_nav_menu" );

	footer_menus.on(
		"click", function() {
			var menu = $( this );

			if (menu.hasClass( "open" )) {
				menu.removeClass( "open" );
			} else {
				menu.addClass( "open" );
			}
		}
	);

})( jQuery );
